import React from "react"
import ReactDOM from "react-dom"

import moment from "moment"
import locale from "zhihu-moment-locale"
import za from "za-helper"
import "resource/css/common.css"
import "resource/css/global.css"
import LazyLoad from "@/components/LazyLoad"
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import { prefetchApps } from 'qiankun'

function getHost() {
  if (/(localhost)|(127\.0\.0\.1)/.test(window.location.origin)) {
    return '//localhost:12306'
  } else if (/zm-web--box-(\d+)-/.test(window.location.hostname)) {
      return window.location.origin.replace('zm-web', 'commerce-message-center').replace('--zm-', '--message-webapp-')
  } 
    return 'https://message-webapp.zhihu.com'
  
}

const host = getHost()

moment.defineLocale("zh-cn", locale)
moment.locale("zh-cn")

za.init({
  shouldAutoTrackPageShow: false, // 自动记录 trackPageShow()
  shouldAutoTrackOpenUrl: false, // 为 <a> 自动添加 OpenUrl 事件
  shouldAutoTrackPageMonitor: false // 自动记载页面性能的 trackMonitor()
}).catch(() => {})
let App = LazyLoad(() => import("./App.back.js"))

Promise.resolve().then(() => {
  prefetchApps([
    {name: 'microApp-period-list', entry: `${host}/notifications/list`},
    {name: 'microApp-period-settings', entry: `${host}/notifications/settings`},
  ])
})

const config = {
  locale: zhCN,
}
const render = () => {
  ReactDOM.render((
    <ConfigProvider {...config}>
      <App />
    </ConfigProvider>
  ), document.getElementById("main"))
}
render()
